import React from "react";
import classNames from "classnames";
import Typography, { TypographySize } from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

export type ButtonVariant =
  | "primary"
  | "text"
  | "outlined"
  | "blueGradient"
  | "iconOnly"
  | "danger"
  | "auth";

interface ButtonProps {
  label?: string | React.ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  loading?: boolean;
  variant?: ButtonVariant;
  icon?: React.ReactNode;
  stopPropagation?: boolean;
  textSize?: TypographySize;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  variant = "primary",
  icon,
  stopPropagation,
  textSize = "sm",
  className = "",
}) => {
  const isDisabled = disabled || loading;
  const variantClass = cls[variant];

  const click = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) e.stopPropagation();
    onClick(e);
  };

  return (
    <button
      className={classNames(
        cls.button,
        variantClass,
        { [cls.disabled]: isDisabled },
        className
      )}
      type={type}
      onClick={click}
      disabled={isDisabled}
    >
      <>
        {variant === "iconOnly"
          ? icon
          : icon && <div className={cls.icon}>{icon}</div>}
        {variant !== "iconOnly" &&
          label &&
          (typeof label === "string" || typeof label === "number" ? (
            <Typography className={cls.label} size={textSize} lineHeight={1}>
              {label}
            </Typography>
          ) : (
            <>{label}</>
          ))}
      </>
      {loading && <div className={cls.spinner} aria-label="Loading" />}
    </button>
  );
};

export default Button;
